import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { t } from "@/lib/i18n";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState("checking");
  const [credits, setCredits] = useState(0);
  const sid = params.get("session_id");

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setCredits(data.credits);
        if (data.payment_status === "paid") { setState("paid"); refresh(); return; }
        if (data.status === "expired") { setState("failed"); return; }
      } catch { /* retry */ }
      if (++tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    const paypalId = params.get("provider") === "paypal" ? params.get("token") : null;
    const capture = async () => {
      try {
        const { data } = await api.post(`/payments/paypal/capture/${paypalId}`);
        setCredits(data.credits);
        if (data.payment_status === "paid") { setState("paid"); refresh(); } else setState("failed");
      } catch { setState("failed"); }
    };
    if (paypalId) capture(); else if (sid) poll(); else setState("failed");
    return () => clearTimeout(timer);
  }, [sid, refresh, params]);

  return (
    <div className="max-w-md mx-auto hf-card p-8 text-center mt-10" data-testid="payment-status-card">
      {state === "checking" && <><Loader2 className="w-10 h-10 mx-auto animate-spin text-amber-600" /><p className="font-display font-bold text-xl mt-4">{t("Confirming payment…")}</p></>}
      {state === "paid" && <><CheckCircle2 className="w-12 h-12 mx-auto text-emerald-600" /><p className="font-display font-black text-2xl mt-4" data-testid="payment-success-msg">{credits} {t("credit")}{credits > 1 ? "s" : ""} {t("added")}</p><p className="text-sm text-slate-600 mt-2">{t("Your wallet has been topped up.")}</p></>}
      {(state === "failed" || state === "timeout") && <><XCircle className="w-12 h-12 mx-auto text-red-600" /><p className="font-display font-bold text-xl mt-4">{state === "timeout" ? t("Still processing — check your wallet shortly") : t("Payment not completed")}</p></>}
      <Link to="/wallet" className="hf-btn-dark mt-6" data-testid="back-to-wallet-btn">{t("Back to wallet")}</Link>
    </div>
  );
}
